module.exports = "<div class=\"time-block-wrapper q-marg-vert-md q-text-left\"> <div class=\"q-checkmark-radio q-cr-with-label time-block-div\" data-time-slot-index=\"{%- index %}\"> <label> <input type=radio name=avail-time-radio> <span class=q-checkmark-radio-label-inner></span> <span class=q-cr-label> <span class=q-boldest> {%- timeStamp %} </span> </span> </label> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/components/scheduler/html/templates/timeBlockTemplate.html
// module id = 1172
// module chunks = 1